import { EpimsBaseEntityDto } from './epim-base.dto';
export class DocumentPhysicalLocationDto extends EpimsBaseEntityDto {

    DocumentPhysicalLocationId: string;

    DocumentPhysicalLocationName: string;

   

}